import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAtom } from 'jotai';
import HomeSkeleton from './components/skeletons/home.skeleton';
import { getAuthToken } from './helpers/auth.helper';
import ApiCaller from './services/api/APICaller';
import { authState, initialAuthState } from './state/auth.state';



const AuthProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [auth, setAuth] = useAtom(authState);
    useEffect(() => {
        getAuthDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Get the logged in user details if available
     */
    const getAuthDetails = () => {
        const token = getAuthToken();
        if (token && !auth.isLoggedIn) {
            const apiCaller = new ApiCaller('auth');
            apiCaller.getData('me').then((data) => {
                if (data?.success) {
                    const user = data?.data;
                    setAuth({
                        isLoggedIn: true,
                        userRole: user?.roleId?.roleName,
                        email: user?.email,
                        firstName: user?.firstName,
                        lastName: user?.lastName,
                        profilePic: user?.profilePic,
                        status: user?.status
                    });
                } else {
                    setAuth(initialAuthState)

                }

            })
                .catch((_err) => console.log(_err))
                .finally(() => setIsLoading(false))

        } else {
            setIsLoading(false);
        }
    }

    return (
        <>
            {isLoading ? <HomeSkeleton /> : children}
        </>
    )
}

AuthProvider.propTypes = {
    children: PropTypes.any
}
export default AuthProvider;